module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_1.ec6f1924.jpg";